import { useMutation, useQuery, useQueryClient, type UseQueryResult } from '@tanstack/react-query';

import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';
import { businessSchema, type Business } from '@/lib/schemas/business';

import { businessApi } from './api';

export function useBusiness(slug: string, enabled = true): UseQueryResult<Business, Error> {
  return useQuery({
    queryKey: queryKeys.business(slug),
    queryFn: ({ signal }) => businessApi.get(slug, signal),
    enabled: enabled && slug.length > 0,
  });
}

export function useUpdateBusiness(slug: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: Record<string, unknown>) =>
      apiClient.patch(`/businesses/${slug}`, businessSchema, { body }),
    onSuccess: (business) => {
      queryClient.setQueryData(queryKeys.business(slug), business);
      // The display name follows the business name, so the session is stale.
      void queryClient.invalidateQueries({ queryKey: queryKeys.session });
      void queryClient.invalidateQueries({ queryKey: queryKeys.profileRoot });
    },
  });
}
